import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild, HostListener } from '@angular/core';
import { progressJSFun } from '../../../../assets/js/progress.js'
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CourseCompletionService } from 'src/app/services/course-completion/course-completion.service';
import { CourseService } from 'src/app/services/course/course.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { Location } from '@angular/common';
import { GlobalService } from 'src/app/services/global/global.service';
import { CourseComplettionComponent } from '../course-complettion/course-complettion.component';
import { AlertComponent } from '../../alert/alert.component';
import { Clipboard } from '@angular/cdk/clipboard';
export interface ContentDetail {
  type: string,
  exam_data: any,
  result_data: any,
  data: any,
}
//you should get result data at two places 1)in response of track sub section and 2)when exam is already given by user 
@Component({
  selector: 'app-course-preview',
  templateUrl: './course-preview.component.html',
  styleUrls: ['./course-preview.component.scss']
})

export class CoursePreviewComponent {
  @ViewChild('miframe') myIframe!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('video') video!: ElementRef;
  @ViewChild('audio') audio!: ElementRef;
  public sectionArr: any[] = []
  public panelOpenState: boolean = false;
  public progressValue: number = 100;
  @Input() sidebarSize: any;
  public coursePreviewType: string = "desktop";
  public isSideMenuShow: boolean = true;
  public paramsData: any;
  public subSectionId!: string;
  public sectionId!: string;
  public courseId!: string;
  public purchaseId!: string;
  public imageURL: string = GlobalService.imageURL;
  public subSectionData: any
  public safeUrl!: string;
  public zoom: any = 1;
  public isPlayButton: boolean = true;
  public isSpinnerLoading: boolean = true;
  public isBtnDisabled: boolean = true;
  public getCurrentTime: any
  public trackData: any[] = [];
  public isSetExam: boolean = false;
  private examType!: string;
  public isIframeLoading: boolean = false;
  public iFramePer: any;
  public sliderTimer: any;
  public courseData: any;
  public sectionDataArr: any[] = []
  public isAllSectionCompleted: boolean = false;
  public totalSlide: any;
  public currentSlide: any;
  public isReset: boolean = true;
  public contentDetail: ContentDetail = {
    type: "",
    exam_data: "",
    result_data: null,
    data: ""
  }
  public courseStage!: string;
  public isBackAvailable: boolean = false;
  public smallDevcieBtn={
    isNext:true,
    isBack:true,
    isLandscape:false,
  }
  public settingsArr: any[] = [
    { key: 'view_all_pages', value: false, isSettingMet: false, type: ['pdf'] },
    { key: 'confirm_btn', value: false, isSettingMet: false, type: ['text', 'audio', 'pdf', 'video', 'file', 'image', 'link', 'youtube'] },
    { key: 'allow_user_download', value: false, isSettingMet: false, type: ['pdf', 'video'] },
    { key: 'watch_entire_video', value: false, isSettingMet: false, type: ['video'] },
    { key: 'user_must_scroll', value: false, isSettingMet: false, type: ['text'] },
    { key: 'allow_copy_clipboard', value: false, isSettingMet: false, type: ['text'] },
    { key: 'user_must_download_file', value: false, isSettingMet: false, type: ['file', 'image'] },
  ];
  public isAllSettingsApplied: boolean = false;
  public isDownloadAllowed: boolean = false;
  public isCopyTextAllowed: boolean = false;
  private totalPdfPages!: number;
  public isConfirmBtn: boolean = false;
  public themeUrl!: string;
  public rightIconAlign: any;
  public sideMenuWidth: any;
  public isCourseModalOpen:boolean=false;
  constructor(private renderer: Renderer2, private el: ElementRef, private appService: AppService, private courseService: CourseService,
    private activatedRoute: ActivatedRoute, public sanitizer: DomSanitizer, private cd: ChangeDetectorRef, public location: Location,
    private individualService: IndividualService, private router: Router, public dialog: MatDialog, private courseCompletionService: CourseCompletionService,
    private commonService: CommonService, private clipboard: Clipboard) {
    this.renderer.setStyle(this.el.nativeElement, '--sidebar-width-new', this.sidebarSize);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenWidth();
  }
  ngOnInit(): void {

    this.checkScreenWidth()
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    progressJSFun()
    setTimeout(() => { progressJSFun() }, 200)
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length !== 0) {
        this.paramsData = params;
        this.subSectionId = params["s_si"]
        this.sectionId = params["s_i"]
      }
    })
    // this we are not clearing on destroying the component because if user is on slide 6 and then he goes back then slides will start 
    //from slide 6 but total slides will get reset if go to any other course and then comes back
    localStorage.setItem('training-portal.totalSlide', '0');
    localStorage.setItem('training-portal.currentSide', '0');
    localStorage.removeItem('training-portal.isLastSlide');
    let cData = JSON.parse(this.appService.getSessionData('courseData'))
    this.courseData = cData;
    this.sectionId = this.courseData.s_i;
    this.subSectionId = this.courseData.s_si;
    this.purchaseId = this.courseData.p_i;
    this.courseId = this.courseData.c_i;
    this.sectionDataArr = this.courseData.section_arr;

    if (this.appService.getSessionData('subSectionData')) {
      this.getCurrentTime = new Date().getTime() //this is required for spend_time node of track sub section
      // setting here section and subsection id to check back btn is available or not
      let subSecData=JSON.parse(this.appService.getSessionData('subSectionData'))["data"]
      this.sectionId=subSecData["sub_s"][0].s_i
      this.subSectionId=subSecData["sub_s"][0].id
      this.getSubSectionDetail(JSON.parse(this.appService.getSessionData('subSectionData')))
    }
    else {
      this.detail()
    }

  }
  onChangePreviewType(value: string) {
    this.coursePreviewType = value
  }
  getUrl(url){
   return this.appService.getUrl(url)
  }
  checkScreenWidth() {
    const windowWidth = window.innerWidth;
    this.isSideMenuShow = window.innerWidth >= 1200;
    this.checkAlignment()
    // this.smallDevcieBtn.isLandscape=true;
    // have added this type of condition as if it is iframe nad user is using mobile landscape view then user was unable to view the iframe properly
    if(windowWidth<=480 && window.screen.orientation.type=="landscape-primary"){
      this.smallDevcieBtn.isLandscape=true;
    }
  }
  checkAlignment() {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 1200) {
      // this.sideMenuWidth = 'auto'
      if (this.isSideMenuShow) {
        this.sideMenuWidth = 'auto'
        this.rightIconAlign = '-15px'
      }
      else {
        // this.rightIconAlign = "350px"
        this.sideMenuWidth = '27px'
        this.rightIconAlign = '-15px'
        // this.rightIconAlign = "0px"
      }
    }
    else {
      this.sideMenuWidth = '27px'

      if (!this.isSideMenuShow) {
        this.rightIconAlign = '-15px'
      }
      else {
        this.rightIconAlign = '-15px'
      }
    }
    this.renderer.setStyle(this.el.nativeElement, '--sidebar-width-new', this.sideMenuWidth);
  }
  onSideMenuDisplay() {

    this.isSideMenuShow = !this.isSideMenuShow;
    this.checkAlignment()
  }
  getSafeUrl(data) {
    return this.safeUrl;
  }
  extractVideoId(url: string) {
    let videoId = '';
    if (url.includes("youtube.com/watch")) {
      const start = url.indexOf("v=") + 2;
      let end: any = url.indexOf("&", start);
      if (end === -1) {
        end = undefined;
      }
      videoId = url.substring(start, end);
      return this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else if (url.includes("youtube.com/shorts/")) {
      const urlParts = url.split("/");
      videoId = urlParts[urlParts.length - 1];
      return this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else {
      return ""
    }
  }
  onDownloadFile(data) {
    // this.appService.downloadFile(this.imageURL + data, 'course_file')
    this.updateSetting('user_must_download_file', true)
  }
  onSubSection(val: any, item: any, section_detail: any) {
    this.sectionId = val
    this.subSectionId = item.s_si
    // previous subsection should completed if user is trying to give exam
    let isAllSubSectionCompleted = this.arePreviousSubSectionsCompleted(section_detail["sub_s"])
    if (item.type != "exam" || ((item.type == "exam") && isAllSubSectionCompleted)) {
      this.detail()
    }
    else {
      this.showAlert('alert_complete_sub_section')
    }
    const windowWidth = window.innerWidth;
    if(windowWidth<1200 && this.isSideMenuShow){
      this.isSideMenuShow=false;
      this.checkAlignment()
    }
  }
  arePreviousSubSectionsCompleted(arr: any[]): boolean {
    // any changes here make in employee portal also
    // Check if all previous objects have is_completed set to true
    //have give here length -1 as wants to check all the sub section above exam and not exam itself
    for (let i = 0; i < arr.length - 1; i++) {
      if (arr[i].is_cp !== 1) {
        return false;
      }
    }
    // If all previous objects have is_completed set to true, return true
    return true;
  }
  pauseSound(event) {
    // this.isPlayButton = true;
    this.trackData = [];
    let per = Math.trunc((parseInt(event.target.currentTime) * 100) / parseInt(event.target.duration)) ?
      Math.trunc((parseInt(event.target.currentTime) * 100) / parseInt(event.target.duration)) : 0;
    let data = {
      s_si: parseInt(this.subSectionId),
      time: event.target.currentTime,
      per: per
    }
    this.trackData.push(data);
    if (per == 100) {
      this.isPlayButton = true
    }
    // setting per for subsection with the below code :
    this.subSectionData.per = per;
    // for (let data of this.sectionDetailsData.sub_section) {
    if (this.subSectionData.per < 80 || this.subSectionData.per == null) {
    
      this.isBtnDisabled = true;
      // break;
    } else {
      this.isBtnDisabled = false;
      if (this.subSectionData.type == 'video') {
        this.updateSetting('watch_entire_video', true)
      }
    }
    }
  pageRendered(e: any) {
    if (e.pageNumber == this.totalPdfPages) {
      // alert("whole pdf viewed")
      this.updateSetting('view_all_pages', true)
    }
  }
  afterLoadComplete(pdf): void {
    this.totalPdfPages = pdf.numPages
  }
  onZoomIn() {
    this.zoom = this.zoom + 0.25
  }
  onZoomOut() {
    if (this.zoom > 1) {
      this.zoom = this.zoom - 0.25
    }
  }
  onPlayPauseAudio() {
    // this.isPlayButton = !this.isPlayButton;
    const audioElement: HTMLAudioElement = this.audio.nativeElement;
    if (audioElement.paused) {
      audioElement.play();
      this.isPlayButton = false
    }
    else {
      this.isPlayButton = true
      audioElement.pause();
    }
  }
  onScroll() {
    const container = this.scrollContainer.nativeElement;
    // Check if the user has scrolled to the bottom or to a certain point
    let scrolledBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;
    if (this.isBtnDisabled) {
      this.isBtnDisabled = !scrolledBottom;
    }
    if (this.isBtnDisabled == false) {
      this.updateSetting('user_must_scroll', true)
      this.subSectionData.per = 100;
      let data = {
        s_si: parseInt(this.subSectionId),
        time: 1,
        per: this.subSectionData.per
      }
      this.trackData.push(data);
    }
  }
  //all the below code is for iframe 
  bindEvent(element, eventName, eventHandler) {
    // the above function is used to transfer the data values 
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler);
    }
  }
  detail() {
    let objData = {
      is_p: this.courseData["p_si"],
      c_i: this.courseId,
      p_i: this.purchaseId,
      s_i: this.sectionId,
      s_si: this.subSectionId,
      t: this.courseData["c_t"]
    }
    //current time called here as we need to calculate the spend time of each sub section now as this function called multiple this variable set upped heer
    this.getCurrentTime = new Date().getTime()
    this.isSpinnerLoading = true;
    this.individualService.subSectionDetail(objData).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.storeSessionData('subSectionData', JSON.stringify(success))
          this.getSubSectionDetail(success)
     
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  getSubSectionDetail(success) {
    this.sectionArr = []
    this.isSpinnerLoading = false;
    this.themeUrl = success['data']['tem_img']
    this.sectionArr = success['data']["s_a"]
    this.examType = success["data"]["e_t"]
    this.subSectionData = success["data"]["sub_s"][0]
    this.progressValue = success["data"]["c_p"]
    if(this.sectionArr[this.sectionArr.length-1]["arr"][this.sectionArr[this.sectionArr.length-1]["arr"].length-1]==this.subSectionData.id){
      this.smallDevcieBtn.isNext=false
    }
    else{
      this.smallDevcieBtn.isNext=true;
    }
    if(this.sectionArr[0]["arr"][0]==this.subSectionData.id){
      this.smallDevcieBtn.isBack=false
    }
    else{
      this.smallDevcieBtn.isBack=true
    }
    setTimeout(() => { progressJSFun() }, 200)
    if (success["data"]["is_e"] == 1) {
      this.isSetExam = true;
    }
    if (this.subSectionData.type != 'exam') {
      this.contentDetail.type = this.subSectionData.type
    }
    if (this.subSectionData.type == "exam") {
      this.courseStage = 'exam_pending'
      this.commonExamEvent()
    }
    if (this.subSectionData.type == 'link') {
      this.getSafeUrl(this.subSectionData.data)
    }
    if (this.subSectionData.type == 'text') {
      setTimeout(() => { this.onScroll() }, 200)
    }
    if (this.subSectionData.type == 'pdf') {
      this.getSafeUrl(this.imageURL + this.subSectionData.data)
    }
    //here setting the per to 100% so that user can move to next section 
    if (this.subSectionData.type == 'youtube' || this.subSectionData.type == 'image' ||
      this.subSectionData.type == 'document' || this.subSectionData.type == 'pdf' ||
      this.subSectionData.type == 'link' || this.subSectionData.type == 'file') {
      this.subSectionData.per = 100;
      this.isBtnDisabled = false;
      let data = {
        s_si: parseInt(this.subSectionId),
        time: 1,
        per: this.subSectionData.per
      }
      this.trackData.push(data);
    }
    if (this.subSectionData.type == "iframe") {
      this.isIframeLoading = true
    }
    setTimeout(() => {
      if (this.subSectionData.type == "iframe") {
        const iframe: any = document.getElementById('iframe');
        iframe.src = this.subSectionData.data;
        iframe?.addEventListener('load', () => {
          let iframeWindow = iframe.contentWindow || iframe.contentWindow.document;
          // var htmlContent = iframeWindow.documentElement.outerHTML;
        });
      }
    }, 1000)
    setTimeout(() => {
      // if (this.sectionDetailsData.sub_section) {
      // for (let data of this.sectionDetailsData.sub_section) {
      if (this.subSectionData.type == 'iframe') {
        // this.iframeSubSectionId = data.sub_section_id;
        this.getPer();
      }
      //if section completed per is less than 80 or null don't allow to proceed
      if (this.subSectionData.per < 80 || this.subSectionData.per == null) {
        this.cd.markForCheck();
        this.isBtnDisabled = true;
      } else {
        this.cd.markForCheck();
        this.isBtnDisabled = false;
      }
      this.isIframeLoading = false;
    }, 1000)
    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
    if (currentSectionIdIndex == 0 && currentSubSectionIndex == 0) {
      this.isBackAvailable = false
    }
    else {
      this.isBackAvailable = true;
    }
    if (this.subSectionData.is_cp == 1) {
      this.isBtnDisabled = false
      this.subSectionData.per = 100;
    }
    this.requiredSettings()
  }

  changeSubSectionCompletionStatus(sectionId, subSectionId) {
    for (let i = 0; i < this.sectionDataArr.length; i++) {
      if (sectionId == this.sectionDataArr[i].s_i) {
        for (let j = 0; j < this.sectionDataArr[i].sub_s.length; j++) {
          if (subSectionId == this.sectionDataArr[i].sub_s[j].s_si) {
            this.sectionDataArr[i].sub_s[j]["is_cp"] = 1
          }
        }
      }
    }
  }
  getPer() {
    this.isAllSettingsApplied = true //by default if iframe course then make all settings applied true
    let inPer100: boolean = false;
    // this.isReset = true;
  
    this.sliderTimer = setInterval(() => {
      var isLastSlide = localStorage.getItem('training-portal.isLastSlide');
      if (isLastSlide == 'true') {
        let cSlide: any = localStorage.getItem('training-portal.currentSide');
        let tSlide: any = localStorage.getItem('training-portal.totalSlide');
        this.iFramePer = 100;
        if (this.iFramePer >= 100 && !inPer100) {
          inPer100 = true;
          clearInterval(this.sliderTimer);
          this.cd.markForCheck();
          this.isBtnDisabled = false;

          let data: any = {
            s_si: this.subSectionId,
            per: this.iFramePer
          }
          this.trackData = []
          this.trackData.push(data)
        }
      } else if (isLastSlide == 'false') {
      } else {
        if(this.subSectionData.type=="iframe"){
          this.isBtnDisabled = true;
        }
       
      }
    }, 1000);
  }
  ngAfterViewInit() {
    this.bindEvent(window, 'message', (e) => {
      if(e.data){
        let receive = JSON.parse(e.data);
        let tSlide: any = localStorage.getItem('training-portal.totalSlide');
        if (this.iFramePer == 0 || !receive.current_slide) {
          this.totalSlide = receive.total_slide;
          this.isReset = false;
          localStorage.setItem('training-portal.totalSlide', this.totalSlide);
        }
        if (receive.current_slide) {
          this.currentSlide = receive.current_slide;
          localStorage.setItem('training-portal.currentSide', this.currentSlide);
          localStorage.setItem('training-portal.isLastSlide', receive.is_last_slide);
        };
      }
    });
  }
  onGoBack() {
    this.location.back()
  }
  onBack() {
    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
    // current sub section is not first item of section id's arr then do -1 of current sub section index
    if (currentSubSectionIndex > 0) {
      this.subSectionId = this.sectionArr[currentSectionIdIndex]["arr"][currentSubSectionIndex - 1]
    }
    // if current sub section is first item of section array then -1 section and go one section up nad then view its last sub seciton as user is going back
    else {
      if (currentSectionIdIndex > 0) {
        this.sectionId = this.sectionArr[currentSectionIdIndex - 1]["id"]
        this.subSectionId = this.sectionArr[currentSectionIdIndex - 1]["arr"][this.sectionArr[currentSectionIdIndex - 1]["arr"].length - 1]
      }
    }
    this.detail()
  }
  onNext(){
    this.getNextId()
    this.detail()

  }
  getNextId() {
    // if last section or result then also the subs ection api was being called hence adding this boolean tonot call detail api if course completed modal is open
    this.isCourseModalOpen=false;

    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    if (!this.isAllSectionCompleted) {
      if (currentSectionIdIndex + 1 <= this.sectionArr.length) {
        let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
        //should not be last sub section
        //if last sub section then move to next section's first sub section
        if (this.sectionArr[currentSectionIdIndex]["arr"].length == currentSubSectionIndex + 1) {
          if (currentSectionIdIndex + 1 != this.sectionArr.length) {
            this.sectionId = this.sectionArr[currentSectionIdIndex + 1]["id"]
            this.subSectionId = this.sectionArr[currentSectionIdIndex + 1]["arr"][0]
            let sData = {
              sectionId: this.sectionId,
              subSectionId: this.subSectionId
            }
            // return sData
          }
          else {
            return this.courseCompleted()
          }
        }
        else {
          this.subSectionId = this.sectionArr[currentSectionIdIndex]["arr"][currentSubSectionIndex + 1]
        }
      }
      else {
        //all sections are done
        return this.courseCompleted()
      }
    }
    else { return this.courseCompleted() }
  }
  onSubmit() {
    var getSecondDiff = (new Date().getTime() - this.getCurrentTime) / 1000;
    getSecondDiff /= 60 / 60;
    this.isSpinnerLoading = true;
    let data = {
      p_i: this.purchaseId,
      c_i: this.courseId,
      s_si: this.subSectionId,
      s_i: this.sectionId,
      sp_ti: Math.abs(Math.round(getSecondDiff)),
      t: this.courseData["c_t"],
      track_data: this.trackData
    }
    this.individualService.tracking(data).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          // change download btn status as it will be next section
          this.isDownloadAllowed=false
          this.changeSubSectionCompletionStatus(this.sectionId, this.subSectionId)
          clearInterval(this.sliderTimer);
          localStorage.setItem('training-portal.totalSlide', '0');
          localStorage.setItem('training-portal.currentSide', '0');
          localStorage.removeItem('training-portal.isLastSlide');
          this.iFramePer = 0;
          this.trackData = [];
          setTimeout(() => { progressJSFun() }, 200)
          if (success.is_cs == 1) {
            this.isAllSectionCompleted = true;
          }
          // if sub section was exam then next show the result if not then go to next id
          if (this.subSectionData.type == 'exam') {
            this.courseStage = "result"
            this.contentDetail.type = "result"
            this.contentDetail.result_data = success["r_d"]
            this.commonExamEvent()
          }
          else {
            this.contentDetail.type = this.subSectionData.type
            this.getNextId()
            this.detail()
          }
          // if (this.subSectionData.type != 'exam') {
          //   // this.isResultShow=false;           
          // }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onCompleted(){
  //  if course is completed then 
    if(this.progressValue<100){
      if(this.subSectionData.is_cp){
        this.getNextId()
        this.detail()
      }
      else{
        this.onSubmit()
      }
    }
    else{
      this.courseCompleted()
    }
    // if(this.subSectionData.is_cp && ){}
  }
  courseCompleted() {
    //adding this as when modal open after completing the whole course then iframe is not viewed
    if (this.subSectionData) {
      if (this.subSectionData.type == "iframe") {
        setTimeout(() => {
          if (this.subSectionData.type == "iframe") {
            const iframe: any = document.getElementById('iframe');
            iframe.src = this.subSectionData.data;
          }
        }, 1000)
      }
    }
    if (this.isAllSectionCompleted||this.progressValue==100) {
      if (!this.isSetExam) {
        this.onModal("informational")
      }
      else if (this.isSetExam && this.examType == "final") {
        this.onModal("exam")
      }
      else if (this.isSetExam && this.examType != "final") {
        // alert("overall exam is set ")
        this.onModal("exam")
      }
      else {
        // alert("None of the condition is met")
      }
    }
    else {
      //still module are pending
      this.onModal("module")
    }
    //course completed
  }
  onModal(type: String) {
    let data = {
      api_type: type,
      p_i: parseInt(this.purchaseId),
      c_i: parseInt(this.courseId),
    }
    if (this.examType == 'final') {
      data["e_t"] = 'f'
    }
    else {
      data["e_t"] = 'o'
    }
    this.isCourseModalOpen=true;
    const dialogRef = this.dialog.open(CourseComplettionComponent, {
      data: data, maxWidth: '552px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.exam_type == 'overall') {
        this.courseStage = "go_to_examList"
        this.commonExamEvent()
      }
    });
  }
  commonExamEvent() {
    if (this.courseStage == 'exam_pending') {
      this.contentDetail.type = 'exam'
      this.contentDetail.exam_data = this.examData()
    }
    else if (this.courseStage == 'exam_submitted') {
      this.trackData = this.contentDetail["data"]
      this.onSubmit()
    }
    else if (this.courseStage == "result") {
      this.contentDetail.type = 'result'
      this.contentDetail.result_data["is_cs"] = this.isAllSectionCompleted; 
      this.progressValue = this.contentDetail.result_data["c_p"] 

      setTimeout(()=>{progressJSFun()},200)
    }
    else if (this.courseStage == 'go_to_examList') {
      this.contentDetail.type = "examList"
      let data = {
        c_i: this.courseId,
        p_i: this.purchaseId,
        t: this.courseData["c_t"],
        e_t: this.examType
      }
      this.contentDetail.data = data
    }
    // else if(this.courseStage)
    else {
      // if none of the above condition then go to next
     
      this.getNextId()
      if(!this.isCourseModalOpen){
        this.detail()
      }
    }
    // this.progressValue=
  }
  examComponentEvent(data: any) {
    if (data.type == 'exam') {
      this.courseStage = "exam_submitted"
      this.contentDetail.data = data["data"]
    }
    if (data.type == 'result') {
      this.courseStage = "result"
      this.contentDetail.result_data = data["data"]
      if(this.examType=="final"||this.examType=="f"){
        this.contentDetail.result_data["is_cs"] = this.isAllSectionCompleted;
      }
      // this.contentDetail.result_data["is_cs"] = this.isAllSectionCompleted;
  
    }
    if (data.type == "exam_pending") {
      this.courseStage = "exam_pending"
      this.subSectionData.e_i = data["e_i"]
      this.subSectionData.type = "exam"
    }
    if (data.type == "go_to_examList") {
      this.courseStage = "go_to_examList"
    }
    if(data.type=="result_shown"){
      this.courseStage="result_shown"
    }
    this.commonExamEvent()
  }
  examData() {
    //the same function called from two place i.e  exam list and individual exam component
    let data = {
      c_i: this.courseId, //course id
      p_i: this.purchaseId, //purchase
      s_i: this.sectionId, //section
      s_si: this.subSectionId, //sub section
      p_si: this.courseData["p_si"],
      e_i: this.subSectionData.e_i, //exam id
      e_t: 'o', //two types of exam i.e section and overall from here it will be section exams
      is_e: 't', //is exam set 
      c_t: this.courseData["c_t"],
      is_all_section_complete: this.isAllSectionCompleted
    }
    if (this.examType == 'final') {
      data["e_t"] = 'f'
    }
    else {
      data["e_t"] = 'o'
    }
    if (!this.isSetExam) {
      data["is_e"] = 'f'
    }
    // this.contentDetail.exam_data=data,
    // this.contentDetail.type="exam"
    return data;
  }

  showAlert(type) {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: type, }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // if (result["delete_content"] == true) {
        // this.onCourseList()
        // }
      }
    });
  }
  onClose() { }
  onCopyText() {
    this.clipboard.copy(this.scrollContainer.nativeElement.textContent)
  }
  onDownload() {
    this.appService.downloadFile(this.subSectionData.data, 'course_work')
  }
  onCopy() { }
  requiredSettings(): void {
    this.isDownloadAllowed = false;
    this.isCopyTextAllowed = false;
    this.isConfirmBtn = false
    this.isAllSettingsApplied = false
    if(this.subSectionData.o_stt==null){
      this.subSectionData.o_stt=[]
    }
    const keysToSetTrue = this.subSectionData.o_stt;
    keysToSetTrue.forEach(key => {
      const setting = this.settingsArr.find(setting => setting.key === key);
      if (setting) {
        setting.value = true;
      }
    });
    for (let i = 0; i < this.settingsArr.length; i++) {
      if (this.subSectionData.type == 'pdf' || this.subSectionData.type == 'video'|| this.subSectionData.type == 'image') {
        if ((this.settingsArr[i].key == 'allow_user_download' ||this.settingsArr[i].key=='user_must_download_file' ) && this.settingsArr[i].value == true) {
          this.settingsArr[i].isSettingMet = true
          this.isDownloadAllowed = true
        }
      }
      if (this.subSectionData.type == 'text') {
        if (this.settingsArr[i].key == 'allow_copy_clipboard' && this.settingsArr[i].value == true) {
          this.settingsArr[i].isSettingMet = true
          this.isCopyTextAllowed = true
        }
      }
      if (this.settingsArr[i].key == 'confirm_btn' && this.settingsArr[i].value == true) {
        this.settingsArr[i].isSettingMet = true
        this.isConfirmBtn = true;
      }
    }
    if (this.subSectionData.is_cp == 1) {
      this.isAllSettingsApplied = true;

    }
    else {
      this.checkSettingOfObject()
    }
  }

  checkSettingOfObject() {
    let filteredSettings = this.settingsArr.filter(item => item.type.includes(this.subSectionData.type))
    const isDisabled = filteredSettings.some(item => item.value === true && item.isSettingMet != true);
    if (isDisabled) {
      this.isAllSettingsApplied = false
    }
    else {
      this.isAllSettingsApplied = true
    }
  }
  updateSetting(key: string, newValue: boolean): void {
    const setting = this.settingsArr.find(item => item.key === key);
    if (setting) {
      setting.isSettingMet = newValue;
    }
    this.checkSettingOfObject()
  }
  resetSettings(): void {
    this.settingsArr.forEach(setting => {
      setting.value = false;
    });
  }
  ngOnDestroy(): void {
    clearInterval(this.sliderTimer);
    sessionStorage.removeItem("courseData")
    sessionStorage.removeItem("subSectionData")
  }
}